import { useContext } from "react";
import { AppContext } from "../context/app-data.context";
import { User } from "../models/user";

export const useCurrentUser = (): User => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error("Hook must be used within a AppContextProvider");
  }
  return context.appData.user;
};
